// @flow

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Tile from './Tile';

type Props = {
  tiles: Array<array>,
  tileImages: Array<string>,
  checkMatch: Function,
  currentRotation: string,
  drag: Function,
  placedTiles: Array<array>,
  lastIndex: integer,
};

const Tiles = ({ tiles, tileImages, checkMatch, placedTiles,
  currentRotation, lastIndex }: Props) => (
    <div
      className="absolute inset-y-0 right-0 flex flex-col gap-4 p-4 justify-center z-30 bg-indigo-300 bg-opacity-25"
    >
      <AnimatePresence initial={false}>
        {tiles.map(tile => (
          <motion.div
            key={`tile-${tile}`}
            layout
            transition={{ duration: 0.1 }}
            initial={{ opacity: 0, y: 100, scale: 0.3 }}
            animate={{ opacity: 1, y: 0, scale: 1, transition: { duration: 0.1 } }}
            exit={{ opacity: 0, y: -100, scale: 0.3, transition: { duration: 0.1 } }}
          >
            <Tile
              tile={tile}
              tileImages={tileImages}
              dragEnd={point => checkMatch(tile, placedTiles, tiles, point)}
              currentRotation={currentRotation}
              lastIndex={lastIndex}
              responsive={true}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
);

export default Tiles;
